import { getToken } from '../lib/storage';
import { API_ENDPOINTS } from '../constants';
import { ApiResponse, User } from '../types';
import { apiClient } from './apiClient';

export const fileService = {
   async upload(
      files: File | File[],
      options?: { tenantId?: string; subdir?: string }
    ): Promise<any> {
      const form = new FormData();
    
      const baseUrl = process.env.REACT_APP_API_URL || '';
    
      if (Array.isArray(files)) {
        files.forEach((f) => form.append('file', f));
      } else {
        form.append('file', files);
      }
    
      if (options?.subdir) {
        form.append('subdir', options.subdir);
      }
    
      const endpoint = `${baseUrl.replace(/\/+$/, '')}${((API_ENDPOINTS as any)?.UPLOADS?.CREATE || '').replace(/^\/+/, '/')}`;
    
      const result = await apiClient.post<ApiResponse<any>>(endpoint, form, {
        authenticate: true,
      });
    
      return (result as any).data ?? result;
    },
    async getAgentInstanceById(id: string): Promise<any> {
      const result = await apiClient.get<ApiResponse<any>>(
        API_ENDPOINTS.AGENT_INSTANCES.GET_BY_ID(encodeURIComponent(id)),
        { authenticate: true }
      );
      return (result as any).data ?? result;
    },
    async getImageFromkey(id: string,bucketName:string,contentType?:string): Promise<Response> {
      const result = await apiClient.get<ApiResponse<any>>(
        `${API_ENDPOINTS.UPLOADS.GETONE(id)}?bucketName=${encodeURIComponent(bucketName)}${contentType ? `&contentType=${encodeURIComponent(contentType)}` : ''}`,
        { authenticate: true, }
      );
      return (result as any).data ?? result;
    }


};


